import { provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule} from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {ItemView} from './ProductSearch/ScrollExisting/ItemView/item-view';
import {NgbAccordionModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {ScrollView} from './ProductSearch/ScrollExisting/ScrollView/scroll-view';
import {SearchDropdownMenuComponent} from './CustomComponents/search-dropdown-menu/search-dropdown-menu.component';
import {ProfileComponent} from './UserPages/Profile/profile.component';
import {EnterpriceSassComponent} from './LandingPage/enterprice-sass/enterprice-sass.component';
import {EnterpriceSassNavComponent} from './LandingPage/enterprice-sass/enterprice-sass-nav/enterprice-sass-nav.component';
import {EnterpriceSassFaqComponent} from './StaticSites/FAQPage/faq-page/enterprice-sass-faq/enterprice-sass-faq.component';
import {
    EnterpriceSassHeaderComponent
} from './LandingPage/enterprice-sass/enterprice-sass-header/enterprice-sass-header.component';
import {
    EnterpriceSassFeatureComponent
} from './LandingPage/enterprice-sass/enterprice-sass-feature/enterprice-sass-feature.component';
import {
    EnterpriceSassBuildComponent
} from './LandingPage/enterprice-sass/enterprice-sass-build/enterprice-sass-build.component';
import {
    EnterpriceSassCopyrightComponent
} from './LandingPage/enterprice-sass/enterprice-sass-copyright/enterprice-sass-copyright.component';
import {
    EnterpriceSassFooterComponent
} from './LandingPage/enterprice-sass/enterprice-sass-footer/enterprice-sass-footer.component';
import { GalleryComponent, GalleryModule } from 'ng-gallery';
import { CheckoutComponent } from './ProductSearch/Finalisation/checkout/checkout.component';
import { LoginComponent } from './UserPages/login/login.component';
import { SignUpComponent } from './UserPages/sign-up/sign-up.component';
import { PageNotFoundComponent } from './StaticSites/page-not-found/page-not-found.component';
import { ContactComponent } from './StaticSites/contact/contact.component';
import { ImpressumComponent } from './StaticSites/impressum/impressum.component';
import { SearchMenuRegionsComponent } from './CustomComponents/search-menu-regions/search-menu-regions.component';
import { AboutPage } from './StaticSites/ServicesPage/about-page.component';
import { ServicesListingComponent } from './StaticSites/ServicesPage/services-listing/services-listing.component';
import { TestemonialComponent } from './StaticSites/ServicesPage/testimonial/testemonial.component';
import { MenuComponent } from './LandingPage/NavigationMenu/menu/menu.component';
import { EnterpriceSassWorkComponent } from './ProductSearch/LeadGeneration/lead-geneation-page/enterprice-sass-work/enterprice-sass-work.component';
import { LeadGeneationPageComponent } from './ProductSearch/LeadGeneration/lead-geneation-page/lead-geneation-page.component';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatCheckbox} from '@angular/material/checkbox';
import {PayPalButtonComponent} from './ProductSearch/Finalisation/paypal/paypal-button/paypal-button.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        SignUpComponent,
        ItemView,
        ScrollView,
        ProfileComponent,
        PageNotFoundComponent,
        ContactComponent,

        // Landing
        EnterpriceSassComponent,
        EnterpriceSassHeaderComponent,
        EnterpriceSassFeatureComponent,
        EnterpriceSassBuildComponent,
        EnterpriceSassNavComponent,
        EnterpriceSassCopyrightComponent,
        EnterpriceSassFooterComponent,
        EnterpriceSassWorkComponent,

        ImpressumComponent,
        SearchMenuRegionsComponent,
        SearchDropdownMenuComponent,
        AboutPage,
        ServicesListingComponent,
        TestemonialComponent,
        MenuComponent,
        LeadGeneationPageComponent,
    ],
    imports: [
        CommonModule,
        CarouselModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        EnterpriceSassFaqComponent,
        CheckoutComponent,

        // Nav Components
        NgbNavModule,
        NgbAccordionModule,
        GalleryComponent,
        GalleryModule,

        // Modules
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        RouterModule.forRoot(routes, {useHash: false, anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'}),
        FormsModule,
        MatCheckbox,
        PayPalButtonComponent,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideHttpClient(),
        provideAnimationsAsync(),
    ],
    bootstrap: [AppComponent],
    exports: [
        EnterpriceSassWorkComponent,
        EnterpriceSassFaqComponent
    ]
})

export class AppModule {

}
